import request from '../../../utils/Req';

import config from '../../../config';
import consts from '../../../utils/consts';
import { getCookie } from '../../../utils/helpers';
import { browserHistory } from 'react-router';
import { Gtm } from '../../../utils/gtm';

const { API_URL } = config;
const {
  ACTIONS: { SSIGN_UP },
  GOOGLE_AUTH_PATH,
} = consts;

const requestValidateUser = () => ({ type: SSIGN_UP.REQUEST_VALIDATE_USER });
const receivedValidateUser = (data) => ({
  type: SSIGN_UP.RECEIVED_VALIDATE_USER,
  data,
});
const failedValidateUser = ({ message }) => ({
  type: SSIGN_UP.FAILED_VALIDATE_USER,
  err: message,
});
export const validateUser =
  ({ code, email, error, password, scope, signup }) =>
  (dispatch) => {
    dispatch(requestValidateUser());
    return request
      .get(`${API_URL}/login/user`)
      .query({
        code,
        email,
        error,
        password,
        scope,
        signup,
        path: GOOGLE_AUTH_PATH,
      })
      .withCredentials()
      .then((res) => {
        dispatch(receivedValidateUser(res.body));
        return res.body;
      })
      .catch(({ response }) => {
        if (!response.body.account_status) {
          dispatch(failedValidateUser(response.body.errorMessage));
        } else {
          dispatch(receivedValidateUser(response.body));
        }
        return response.body;
      });
  };

const requestCreateLead = () => ({ type: SSIGN_UP.REQUEST_CREATE_LEAD });
const receiveCreateLead = (data) => ({
  type: SSIGN_UP.RECEIVE_CREATE_LEAD,
  data,
});
const failedToCreateLead = (err) => ({
  type: SSIGN_UP.FAILED_TO_CREATE_LEAD,
  err,
});
export const createLead = (data) => (dispatch) => {
  dispatch(requestCreateLead());
  return request
    .post(`${API_URL}/signup/create-lead`)
    .send(data)
    .set({
      'XSRF-TOKEN': getCookie('XSRF-TOKEN'),
    })
    .withCredentials()
    .then((res) => {
      dispatch(receiveCreateLead(res.body));
      browserHistory.push({
        pathname: '/access/confirm-email',
        state: { email: data.email },
      });
      Gtm.event('Register New Form', 'Incomplete', 'Step 1', undefined, {
        signupToken: res.body.signupToken,
      });
    })
    .catch((err) => {
      let errorMessage;
      switch (err.status) {
        case 403:
        case 422:
          errorMessage = "Please confirm you're not a robot.";
          break;
        case 400:
          errorMessage =
            'You already have an account with CrakRevenue or one of its partners. Please <a href="/login">login</a> or <a href="/password-reset">reset your password</a>.';
          break;
        default:
          errorMessage = 'Unexpected error, if all your informations are valid, please contact support.';
          break;
      }
      dispatch(
        failedToCreateLead({
          status: err.status,
          message: errorMessage,
        })
      );
    });
};

const requestCreateUser = () => ({ type: SSIGN_UP.REQUEST_CREATE_USER });
const receiveCreateUser = (data) => ({
  type: SSIGN_UP.RECEIVE_CREATE_USER,
  data,
});
const failedToCreateUser = ({ message }) => ({
  type: SSIGN_UP.FAILED_TO_CREATE_USER,
  err: message,
});
export const createUser = (data) => (dispatch) => {
  dispatch(requestCreateUser());
  return request
    .post(`${API_URL}/login/user`)
    .send(data)
    .set({
      'XSRF-TOKEN': getCookie('XSRF-TOKEN'),
    })
    .withCredentials()
    .then((res) => {
      dispatch(receiveCreateUser(res.body));
      return res.body;
    })
    .catch((err) => {
      dispatch(failedToCreateUser(err.response.body.errorMessage));
      return err;
    });
};

const requestGoogleGetUrl = () => ({ type: SSIGN_UP.REQUEST_GOOGLE_GET_URL });
const receiveGoogleGetUrl = (data) => ({
  type: SSIGN_UP.RECEIVE_GOOGLE_GET_URL,
  data,
});
const failedToReceiveGoogleGetUrl = () => ({
  type: SSIGN_UP.FAILED_TO_RECEIVE_GOOGLE_GET_URL,
});
export const getGoogleUrl = () => (dispatch) => {
  dispatch(requestGoogleGetUrl());
  return new Promise((fulfill, reject) =>
    request
      .get(`${API_URL}/login/google-url`)
      .withCredentials()
      .query({ path: GOOGLE_AUTH_PATH })
      .end((err, res) => {
        if (!err) {
          dispatch(receiveGoogleGetUrl(res.body.data));
          fulfill(res);
        } else {
          dispatch(failedToReceiveGoogleGetUrl(err));
          reject(err);
        }
      })
  );
};

export const setSignupToken = (data) => ({
  type: SSIGN_UP.SET_SIGNUP_TOKEN,
  data,
});
